// ABOUTME: Pure helper for anchoring a late-arriving assistant message ahead
// of any user turns that never reached the server (#2281), instead of
// blindly appending to the tail. A reply or next-question delivered through
// the resume/notification channel always resolves an EARLIER turn than a
// message still sitting `pending`/`failed` at the tail — appending past it
// makes the transcript read as though the assistant answered the newer,
// unsent question.

import type { AIChatMessage } from '@/stores/aiChatTypes'

function isUnsentUserMessage(message: AIChatMessage): boolean {
  return message.role === 'user' && (message.status === 'pending' || message.status === 'failed')
}

/**
 * Insert `message` immediately before the trailing run of unsent user
 * messages, or append normally when the tail carries none.
 */
export function insertBeforeUnsentTail(
  messages: AIChatMessage[],
  message: AIChatMessage
): AIChatMessage[] {
  let cut = messages.length
  while (cut > 0 && isUnsentUserMessage(messages[cut - 1])) cut--
  if (cut === messages.length) return [...messages, message]
  return [...messages.slice(0, cut), message, ...messages.slice(cut)]
}
